import data from './nimLang_kor.json';
const LocaleConfig = {
    ...data,
}

export default LocaleConfig